import { useContext } from "react"
import { useQuery } from "react-query"

import { MEDIA_CONTENT_KEY } from "constants/queryKeys"

import { ServicesContext } from "contexts/ServicesContext"

import { useErrorToast } from "utils/toasts"

import { DEFAULT_RETRY_MSG } from "utils"

export function useGetMediaHook(params, queryParams) {
  const { mediaService } = useContext(ServicesContext)
  const errorToast = useErrorToast()
  return useQuery(
    [MEDIA_CONTENT_KEY, { ...params }],
    () => mediaService.get(params),
    {
      ...queryParams,
      retry: false,
      onError: () => {
        errorToast({
          id: "get-media-file-error",
          description: `The media file could not be retrieved. ${DEFAULT_RETRY_MSG}`,
        })
        if (queryParams && queryParams.onError) queryParams.onError()
      },
    }
  )
}
